exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leaflet-control-coordinates {\n  background: white;\n  border-radius: 4px;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);\n  cursor: pointer;\n  padding: 2px 5px; }\n\n.leaflet-control-coordinates.hidden {\n  display: none; }\n\n.leaflet-control-coordinates-lng {\n  padding-left: 5px; }\n", ""]);

// exports
